import { ILocalStorageAdapter } from '@intelingu/core/stores/adapters/ILocalStorageAdapter';
import { injectable } from 'inversify';
import { action } from 'mobx';

@injectable()
export class LocalStorageAdapter implements ILocalStorageAdapter {

    @action.bound async write(key, value) {
        return localStorage.setItem(key, value);
    }

    @action.bound async read(key) {
        return localStorage.getItem(key);
    }

    @action.bound async remove(key) {
        return localStorage.removeItem(key);
    }

}
